export const img1 = require('./smoothie-7.svg');
export const img2 = require('./smoothie-2.svg');
export const img3 = require('./smoothie-8.svg');
